module.exports = __webpack_public_path__ + "img/BannerMobile.80b2f955.svg";